import * as SwitchPrimitive from "@radix-ui/react-switch"
import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Тумблер ON/OFF в строке правила. Единственный по-настоящему записывающий
 * элемент экрана, поэтому ведёт себя как железный: щёлкает коротко, во время
 * запроса блокируется (`disabled` ставит вызывающий код), а состояние берёт из
 * базы, а не из локального «уже нажали».
 */
export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      "peer inline-flex h-4 w-8 shrink-0 cursor-pointer items-center rounded-full border transition-colors duration-150 ease-snap disabled:cursor-progress disabled:opacity-60",
      // Синий, а не зелёный: `approve` в этой палитре означает исход скоринга,
      // и красить им «правило включено» значило бы смешать два разных сигнала.
      // В образце тумблер тоже синий.
      "data-[state=checked]:border-accent data-[state=checked]:bg-accent",
      "data-[state=unchecked]:border-line-strong data-[state=unchecked]:bg-surface-sunken",
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        "pointer-events-none block h-3 w-3 rounded-full bg-surface shadow-raised transition-transform duration-150 ease-snap",
        "data-[state=checked]:translate-x-[17px] data-[state=unchecked]:translate-x-[2px]",
        "data-[state=unchecked]:bg-fg-subtle",
      )}
    />
  </SwitchPrimitive.Root>
))
Switch.displayName = "Switch"
